import styled from 'styled-components';

import { NonBenefitNonF2fDoctor } from '@/models/nonBenefit';

interface Props {
  list: NonBenefitNonF2fDoctor[];
  ListEmptyComponent: JSX.Element;
  renderItem: (doctor: NonBenefitNonF2fDoctor, lastItem?: boolean) => JSX.Element;
}
const NonBenefitSearchDoctorList = ({ list, ListEmptyComponent, renderItem }: Props) => {
  return (
    <NonBenefitDoctorListWrapper>
      {list.length > 0 ? list.map((doctor, i) => renderItem(doctor, i === list.length - 1)) : ListEmptyComponent}
    </NonBenefitDoctorListWrapper>
  );
};

export default NonBenefitSearchDoctorList;

const NonBenefitDoctorListWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;
